import styled from '@emotion/styled';
import { css } from '@emotion/react';
import { motion } from 'framer-motion';

const backgroundStyles = ({ theme }) => css`
  min-height: 100vh;
  display: flex;

  background-image: linear-gradient(
    to left top,
    #000948,
    #092d74,
    #1053a2,
    #0d7bd1,
    #00a6ff
  );
`;


const backgroundLatamStyles = ({ theme }) => css`
  min-height: 100vh;
  display: flex;

  background-color: #0D0A21;
`;


const backgroundIaPageStyles = ({ theme }) => css`
  min-height: 100vh;
  display: flex;

  background-image: linear-gradient(
    to left top,
  #171131,
  #39276B,
  #6343B1,
  #895CF1
  );
`;

const backgroundIaLatamPageStyles = ({ theme }) => css`
  min-height: 100vh;
  display: flex;

  background-image: linear-gradient(
    to left top,
  #171131,
  #39276B,
  #6343B1,
  #895CF1
  );
`;

const backgroundAgentesIaLatamPageStyles = ({ theme }) => css`
  min-height: 100vh;
  display: flex;

  background-image: linear-gradient(
    to left top,
  #2C1118,
  #2C1118,
  #2C1118,
  #2C1118
  );
`;

const backgroundExcelPageStyles = ({ theme }) => css`
  min-height: 100vh;
  display: flex;

  /* background-image: linear-gradient(
    to left top,
    #182925,
    #2a4a42,
    #386e60,
    #368570,
    #35a688
  ); */

  /* background-image: linear-gradient(
    to left top,
    #35a688,
    #368570,
    #386e60,
    #2a4a42,
    #182925
  ); */
  background-color: #182925;
`;

const titleStyles = ({ theme, spanColor }) => css`
  font-size: ${theme.typography.xl2};
  color: ${theme.colors.white};
  font-weight: bold;
  line-height: 33.6px;

  span {
    color: ${spanColor || theme.colors.yellow1};
  }
`;

const titleStyles2 = ({ theme, spanColor }) => css`
  font-size: ${theme.typography.xl2};
  color: ${theme.colors.white};
  font-weight: bold;
  line-height: 33.6px;

  span {
    color: ${theme.colors.yellow2};
  }
`;

const titleCertificateStyles = ({ theme }) => css`
  font-size: 28px;
  color: #777777;
  font-weight: bold;
  line-height: 33.6px;

  span {
    color: ${theme.colors.yellow1};
  }

  @media (max-width: ${theme.breaks.medium}) {
    font-size: 20px;
  }
`;

const titleCertificateStyles2 = ({ theme }) => css`
  font-size: 28px;
  color: #777777;
  font-weight: bold;
  line-height: 33.6px;

  span {
    color: ${theme.colors.yellow2};
  }

  @media (max-width: ${theme.breaks.medium}) {
    font-size: 20px;
  }
`;

const textStyles = ({ theme }) => css`
  font-size: ${theme.typography.md};
  color: ${theme.colors.white};
  font-weight: bold;
  line-height: 22.4px;

  span {
    color: ${theme.colors.yellow1};
  }
`;

const textStyles2 = ({ theme }) => css`
  font-size: ${theme.typography.md};
  color: ${theme.colors.white};
  font-weight: bold;
  line-height: 22.4px;

  span {
    color: ${theme.colors.yellow2};
  }
`;

const logoModalStyles = ({ theme }) => css`
  height: 50px;

  @media (max-width: ${theme.breaks.medium}) {
    display: none;
  }
`;

const titleModalStyles = ({ theme, spanColor, color }) => css`
  font-size: ${theme.typography.xl2};
  color: ${color || theme.colors.lightblue};
  line-height: 25px;

  span {
    color: ${spanColor || theme.colors.white};
  }
`;

const titleModalWhiteStyles = ({ theme, spanColor, color }) => css`
  font-size: ${theme.typography.xl2};
  color: ${theme.colors.white};
  line-height: 25px;
`;

const titleModalLatamStyles = ({ theme, spanColor, color }) => css`
  font-size: ${theme.typography.xl2};
  color: #F1CA33;
  line-height: 25px;

  span {
    color: #FFFFFF;
  }
`;

const buttonStyles = ({ theme, disabled, buttonColorHover }) => css`
  background: ${theme.colors.white};
  font-family: 'Montserrat', sans-serif;
  border: 0;
  font-size: 13px;
  border-radius: 12px;
  padding: 15px 30px;
  text-transform: uppercase;
  color: ${theme.colors.background};
  font-weight: bold;
  width: 100%;
  transition: 0.3s;

  &:hover {
    transition: 0.3s;
    background: ${buttonColorHover || theme.colors.blue};
    color: ${theme.colors.white};
  }

  ${disabled &&
  css`
    cursor: not-allowed;
  `}

  span {
    margin-right: 10px;
  }
`;

const buttonAgentesIaLatamStyles = ({ theme, disabled, buttonColorHover }) => css`
  background: #22C55E;
  font-family: 'Montserrat', sans-serif;
  border: 0;
  font-size: 13px;
  border-radius: 12px;
  padding: 15px 30px;
  text-transform: uppercase;
  color: ${theme.colors.background};
  font-weight: bold;
  width: 100%;
  transition: 0.3s;

  &:hover {
    transition: 0.3s;
    background: #15853E;
    color: ${theme.colors.white};
  }

  ${disabled &&
  css`
    cursor: not-allowed;
  `}

  span {
    margin-right: 10px;
  }
`;

const buttonFooterStyles = ({ theme }) => css`
  background: ${theme.colors.lightblue2};
  font-family: 'Montserrat', sans-serif;
  border: 0;
  font-size: 13px;
  border-radius: 12px;
  padding: 15px 30px;
  text-transform: uppercase;
  color: ${theme.colors.white};
  font-weight: bold;
  width: 100%;
  transition: 0.3s;

  @media (max-width: ${theme.breaks.small1}) {
    font-size: 11px;
    padding: 15px 5px;

    svg {
      height: 10px;
      width: 10px;
    }
  }

  @media (max-width: ${theme.breaks.small}) {
    font-size: 10px;
    padding: 13px 10px;
  }

  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    margin-right: 10px;
  }

  &:hover {
    transition: 0.3s;
    background: ${theme.colors.blue};
  }
`;

const buttonLatamFooterStyles = ({ theme }) => css`
  background: #FFFFFF;
  font-family: 'Montserrat', sans-serif;
  border: 0;
  font-size: 13px;
  border-radius: 12px;
  padding: 15px 30px;
  text-transform: uppercase;
  color: #000000;
  font-weight: bold;
  width: 100%;
  transition: 0.3s;

  @media (max-width: ${theme.breaks.small1}) {
    font-size: 11px;
    padding: 15px 5px;

    svg {
      height: 10px;
      width: 10px;
    }
  }

  @media (max-width: ${theme.breaks.small}) {
    font-size: 10px;
    padding: 13px 10px;
  }

  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    margin-right: 10px;
  }

  &:hover {
    transition: 0.3s;
    background: #CE971E;
    color: #FFFFFF;
  }
`;

const buttonFooterStyles2 = ({ theme }) => css`
  background: #463081;
  font-family: 'Montserrat', sans-serif;
  border: 0;
  font-size: 13px;
  border-radius: 12px;
  padding: 15px 30px;
  text-transform: uppercase;
  color: ${theme.colors.white};
  font-weight: bold;
  width: 100%;
  transition: 0.3s;

  @media (max-width: ${theme.breaks.small1}) {
    font-size: 11px;
    padding: 15px 5px;

    svg {
      height: 10px;
      width: 10px;
    }
  }

  @media (max-width: ${theme.breaks.small}) {
    font-size: 10px;
    padding: 13px 10px;
  }

  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    margin-right: 10px;
  }

  &:hover {
    transition: 0.3s;
    background: ${theme.colors.blue};
  }
`;

const buttonFooterStyles3 = ({ theme }) => css`
  background: #EB7538;
  font-family: 'Montserrat', sans-serif;
  border: 0;
  font-size: 13px;
  border-radius: 12px;
  padding: 15px 30px;
  text-transform: uppercase;
  color: ${theme.colors.white};
  font-weight: bold;
  width: 100%;
  transition: 0.3s;

  @media (max-width: ${theme.breaks.small1}) {
    font-size: 11px;
    padding: 15px 5px;

    svg {
      height: 10px;
      width: 10px;
    }
  }

  @media (max-width: ${theme.breaks.small}) {
    font-size: 10px;
    padding: 13px 10px;
  }

  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    margin-right: 10px;
  }

  &:hover {
    transition: 0.3s;
    background: #944922;
  }
`;

const cardStyles = ({ theme, backgroundColor }) => css`
  background: ${backgroundColor || '#3a4547'};

  border-radius: 8px;
  padding: 30px;

  width: 100%;
  height: auto;
`;

const cardLatamStyles = ({ theme, backgroundColor }) => css`
  background: ${backgroundColor || '#16113A'};

  border-radius: 8px;
  padding: 30px;

  width: 100%;
  height: auto;
`;

const ulistStyles = ({ theme, spanColor }) => css`
  color: ${theme.colors.white};
  margin-left: 20px;
  line-height: 25px;

  li {
    font-size: ${theme.typography.md};
    color: ${theme.colors.white};
    font-weight: bold;

    span {
      color: ${spanColor || theme.colors.yellow1};
    }
  }
`;

const ulistStyles2 = ({ theme, spanColor }) => css`
  color: ${theme.colors.white};
  margin-left: 20px;
  line-height: 25px;

  li {
    font-size: ${theme.typography.md};
    color: ${theme.colors.white};
    font-weight: bold;

    span {
      color: ${theme.colors.yellow2};
    }
  }
`;

const titleBigStyles = ({ theme }) => css`
  font-size: ${theme.typography.xl4};
  color: ${theme.colors.background};

  @media (max-width: ${theme.breaks.large}) {
    font-size: ${theme.typography.xl2};
  }

  @media (max-width: ${theme.breaks.small}) {
    font-size: ${theme.typography.xl};
  }

  span {
    color: ${theme.colors.blue};
  }
`;

const titleBigLatamStyles = ({ theme }) => css`
  font-size: ${theme.typography.xl4};
  color: #FFFFFF;

  @media (max-width: ${theme.breaks.large}) {
    font-size: ${theme.typography.xl2};
  }

  @media (max-width: ${theme.breaks.small}) {
    font-size: ${theme.typography.xl};
  }

  span {
    color: #FFFFFF;
  }
`;

const seeMoreStyles = ({ theme }) => css`
  background: ${theme.colors.white};
  padding: 50px 0;
`;

const seeMoreLatamStyles = ({ theme }) => css`
  background: #0D0A21;
  padding: 0 0 50px 0;
`;

const seeMoreAgentesIALatamStyles = ({ theme }) => css`
  background: #4B1C27;
  padding: 20px 0 50px 0;
`;

const containerLimitStyles = ({ theme }) => css`
  max-width: 70rem;
  margin: 0 auto;

  @media (max-width: ${theme.breaks.large}) {
    padding: 0 2rem;
  }

  @media (max-width: ${theme.breaks.small}) {
    padding: 0 1rem;
  }
`;

export const Background = styled('div')(backgroundStyles);
export const BackgroundLatam = styled('div')(backgroundLatamStyles);
export const BackgroundIaPage = styled('div')(backgroundIaPageStyles);
export const BackgroundIaLatamPage = styled('div')(backgroundIaLatamPageStyles);
export const BackgroundAgentesIaLatamPage = styled('div')(backgroundAgentesIaLatamPageStyles);
export const BackgroundExcelPage = styled('div')(backgroundExcelPageStyles);
export const Title = styled('h1')(titleStyles);
export const Title2 = styled('h1')(titleStyles2);
export const TitleCertificate = styled('h1')(titleCertificateStyles);
export const TitleCertificate2 = styled('h1')(titleCertificateStyles2);
export const TitleBig = styled('h1')(titleBigStyles);
export const TitleBigLatam = styled('h1')(titleBigLatamStyles);
export const Text = styled('p')(textStyles);
export const Text2 = styled('p')(textStyles2);
export const LogoModal = styled('img')(logoModalStyles);
export const TitleModal = styled('h1')(titleModalStyles);
export const TitleModalWhite = styled('h1')(titleModalWhiteStyles);
export const TitleModalLatam = styled('h1')(titleModalLatamStyles);
export const Button = styled(motion.button)(buttonStyles);
export const ButtonAgentesIaLatam = styled(motion.button)(buttonAgentesIaLatamStyles);
export const ButtonFooter = styled(motion.button)(buttonFooterStyles);
export const ButtonLatamFooter = styled(motion.button)(buttonLatamFooterStyles);
export const ButtonFooter2 = styled(motion.button)(buttonFooterStyles2);
export const ButtonFooter3 = styled(motion.button)(buttonFooterStyles3);
export const Card = styled('div')(cardStyles);
export const CardLatam = styled('div')(cardLatamStyles);
export const UList = styled('ul')(ulistStyles);
export const UList2 = styled('ul')(ulistStyles2);
export const SeeMoreSection = styled('section')(seeMoreStyles);
export const SeeMoreLatamSection = styled('section')(seeMoreLatamStyles);
export const ContainerLimit = styled('div')(containerLimitStyles);
export const SeeMoreAgentesIALatamSection = styled('section')(seeMoreAgentesIALatamStyles);
